import { Routes } from '@angular/router';
import { BlankComponent } from './layouts/blank/blank.component';
import { FullComponent } from './layouts/full/full.component';
import { AuthGuard } from './auth.guard';
import { HospitalComponent } from './pages/hospital/hospital.component';
import { UserProfileComponent } from './pages/settings/user-profile/user-profile.component';
import { HospitalSettingComponent } from './pages/settings/hospital-setting/hospital-setting.component';
import { SettingTabComponent } from './pages/settings/setting-tab/setting-tab.component';
import { BillChargeResolver } from './pages/settings/hospital-setting/bill-charge/bill-charge.resolver';
import { DoctorSpecialityResolver } from './pages/settings/hospital-setting/doctor-speciality/doctor-speciality.resolver';
import { DoctorDropDownResolver } from './resolvers/doctorDropDown.resolver';
import { BillchargeDropDownResolver } from './resolvers/billchargeDropDown.resolver';
import { IpdTabComponent } from './pages/settings/ipd/ipdTab.component';
import { WardResolver } from './pages/settings/ipd/ward/ward.resolver';
import { RoomTypeResolver } from './pages/settings/ipd/room-type/room-type.resolver';
import { WardDropDownResolver } from './resolvers/wardDropDown.resolver';
import { RoomResolver } from './pages/settings/ipd/room/room.resolver';
import { BedResolver } from './pages/settings/ipd/bed/bed.resolver';
import { IpdComponent } from './pages/ipd/ipd.component';
import { ipdFeatureGuard } from './guards/ipd-feature.guard';
import { DashBoardComponent } from './pages/dashboard/dashboard.component';
import { IpdManagementComponent } from './pages/ipd/ipd-management/ipd-management.component';

export const routes: Routes = [
  {
    path: 'hospital',
    component: HospitalComponent,
    data: {
      title: 'Hospital',
    },
  },
  {
    path: '',
    component: FullComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        redirectTo: '/dashboard',
        pathMatch: 'full',
      },
      {
        path: 'dashboard',
        component: DashBoardComponent,
        title: 'Dashboard',
      },
      {
        path: 'patient',
        loadChildren: () =>
          import('./pages/patient/patient.route').then(m => m.patientRoutes),
      },
      {
        path: 'opd',
        loadChildren: () =>
          import('./pages/opd/opd.route').then(m => m.opdRoute),
      },
      {
        path: 'appointment',
        loadChildren: () =>
          import('./pages/appointment/appointment.route').then(m => m.appointmentRoutes),
      },
      {
        path: 'reports',
        loadChildren: () =>
          import('./pages/reports/reports.route').then(m => m.reportsRoutes),
      },
      {
        path: 'pharmacy',
        loadChildren: () =>
          import('./pages/pharmacy/pharmacy.route').then(m => m.pharmacyRoutes),
      },
      {
        path: 'user',
        loadChildren: () =>
          import('./pages/user/user.route').then((m) => m.userRoutes),
      },
      {
        path: 'clinical',
        loadChildren: () =>
          import('./pages/category/category.route').then(m => m.categoryroutes),
      },
      {
        path: 'Mediclaim',
        loadChildren: () =>
          import('./pages/settings/mediclaim/mediclaim.route').then((m) => m.mediclaimRoutes),
      },
      {
        path: 'appointmenttab',
        loadChildren: () =>
          import('./pages/settings/appointment-tab/appointment-tab.route').then((m) => m.appointmenttabRoutes),
      },
      {
        path: 'Drug',
        loadChildren: () =>
          import('./pages/settings/drug-tab/drug-tab.route').then((m) => m.drugtabRoutes),
      },
      {
        path: 'hospital',
        component: HospitalComponent, //change componenet
        // resolve: { patientData: PatientResolver }, 
        data: {
          title: 'Hospital',
          urls: [
            { title: 'Hospital' },
          ],
        },
      },
      {
        path: 'userprofile',
        component: UserProfileComponent,
        // data: {
        title: 'Userprofile',
      },
      {
        path: 'hospitalsetting',
        component: HospitalSettingComponent, //change componenet
        resolve: {
          billChargedata: BillChargeResolver,
          doctorSpecialityData: DoctorSpecialityResolver,
          // paymenttypedata:PaymentTypeResolver
        },
        data: {
          title: 'Hospital',
          urls: [
            { title: 'Settings', url: '/settings' },
            { title: 'Hospital' },
          ],
        },
      },
      {
        path: 'settings',
        component: SettingTabComponent,
        title: 'Settings', // header Title
        data: {
          title: 'Settings', // breadcrumb Title
          urls: [
            { title: 'Settings' },
          ],
        },
      },
      {
        path: 'ipd/management',
        component: IpdManagementComponent,
        canActivate: [ipdFeatureGuard],
        resolve: {
          ddlward: WardDropDownResolver,
          ddlDoctor: DoctorDropDownResolver,
        },
        title: 'IPD Management',
      },
      {
        path: 'ipd',
        component: IpdTabComponent,
        canActivate: [ipdFeatureGuard],
        resolve: {
          warddata: WardResolver,
        },
        title: 'IPD',
        data: {
          title: 'IPD',
          urls: [
            { title: 'Settings', url: '/settings' },
            { title: 'IPD' }
          ],
        },
      },
      {
        path: 'ipd/ward/:wardId',
        component: IpdTabComponent,
        canActivate: [ipdFeatureGuard],
        resolve: {
          roomtypeData: RoomTypeResolver,
          ddlbillcharge: BillchargeDropDownResolver,
        },
        title: 'Room Type',
        data: {
          title: 'IPD',
          urls: [
            { title: 'Settings', url: '/settings' },
            { title: 'IPD' }
          ],
        },
      },
      {
        path: 'ipd/ward/:wardId/Roomtype/:roomTypeId',
        component: IpdTabComponent,
        canActivate: [ipdFeatureGuard],
        resolve: {
          roomdata: RoomResolver,
        },
        title: 'Room',
        data: {
          title: 'IPD',
          urls: [
            { title: 'Settings', url: '/settings' },
            { title: 'IPD' }
          ],
        },
      },
      {
        path: 'ipd/ward/:wardId/Roomtype/:roomTypeId/Room/:roomId',
        component: IpdTabComponent,
        canActivate: [ipdFeatureGuard],
        resolve: {
          beddata: BedResolver,
        },
        title: 'Bed',
        data: {
          title: 'IPD',
          urls: [
            { title: 'Settings', url: '/settings' },
            { title: 'IPD' }
          ],
        },
      },
      {
        path: 'ipd/admit/:ipdId/patient/:patientId',
        component: IpdComponent,
        canActivate: [ipdFeatureGuard],
        resolve: {
          ddlbillcharge: BillchargeDropDownResolver,
        },
        title: 'IPD',
        data: {
          title: 'IPD',
          urls: [
            { title: 'Settings', url: '/settings' },
            { title: 'IPD' }
          ],
        },
      }
    ],
  },
  {
    path: '',
    component: BlankComponent,
    children: [
      {
        path: 'authentication',
        loadChildren: () =>
          import('./pages/authentication/authentication.routes').then(
            (m) => m.AuthenticationRoutes
          ),
      },
    ],
  },
  {
    path: '**',
    redirectTo: 'authentication/error404',
    pathMatch: 'full',
  },

];
